module.exports = __webpack_public_path__ + "img/icon_sm_ycllysh.71183285.png";